const site = process.env.FATHOM_SITE;
if (site) {
  const s = document.createElement("script");
  s.src = "https://cdn.usefathom.com/script.js";
  s.dataset.site = site;
  s.defer = true;
  document.head.appendChild(s);
}
